// extracted by mini-css-extract-plugin
export default {"cls1":"GWaYDCi6vNaTfBXGqnhw","cls2":"jFiV5jIk5CrCnqgGRilK GWaYDCi6vNaTfBXGqnhw"};